/**
 * Client-side REST refresh intervals (no SSE/WebSocket).
 * Vitals: charts do not need real-time updates.
 * Assigned device: assignment is rare; connection status benefits from fresher polls.
 */

/** ~30 minutes */
export const VITALS_REST_REFRESH_INTERVAL_MS = 30 * 60 * 1000;

/** 5 minutes — frequent enough to catch offline/online transitions mid-session */
export const ASSIGNED_DEVICE_REFRESH_INTERVAL_MS = 5 * 60 * 1000;

/**
 * Consecutive "offline" device reads required before the UI flips a
 * previously-connected device to "disconnected". A single transient/failed
 * poll (network blip, brief 5xx, momentary `device_conn_status: 0`) must not
 * show a false disconnection. With the 5-minute poll interval this is roughly a
 * 5–10 minute grace window before a real offline is surfaced. A device that
 * reports online is always trusted immediately (streak resets to 0).
 */
export const DEVICE_OFFLINE_CONFIRM_READS = 2;

/**
 * After an explicit user-initiated device removal, ignore any `fetchAssignedDevice`
 * result that returns the *same* device for this long. Prevents a stale in-flight
 * read (or a backend that briefly still returns the just-unassigned row) from
 * resurrecting the device the user just removed. A confirming fetch — empty,
 * a different device, or `status: 0` — clears the window sooner.
 */
export const DEVICE_REMOVAL_SUPPRESSION_MS = 5 * 60 * 1000;
